import { render, staticRenderFns } from "./category.vue?vue&type=template&id=799af9e6&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799af9e6')) {
      api.createRecord('799af9e6', component.options)
    } else {
      api.reload('799af9e6', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=799af9e6&", function () {
      api.rerender('799af9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suggestion/components/category.vue"
export default component.exports